<!-- (c) Santosh Sahoo -->
<template>
  <div :class="{ required, 'has-error': !!error, [$props.class]: true }">
    <label v-if="label" :for="uid" class="form-label">{{ label }}</label>
    <textarea
      :id="uid"
      ref="textarea"
      :class="`${className} h-auto ${autosize ? 'autoresize' : ''}`"
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      v-bind="$attrs"
      dir="auto"
      @input="$emit('update:modelValue', $event.target.value)"
      @change="$emit('change', $event.target.value)"
    ></textarea>
    <div v-if="error" class="help-block">{{ error }}</div>
    <div v-if="help" class="help-block">{{ help }}</div>
  </div>
</template>

<script>
import { nextTick } from "vue";
import { basicFormProps } from "./props";

function autoresize({ currentTarget: txtArea }) {
  if (!txtArea) return;
  txtArea.style.height = "auto";
  txtArea.style.height = Math.max(txtArea.scrollHeight, 38) + "px";
  txtArea.scrollTop = txtArea.scrollHeight;
  // window.scrollTo(window.scrollLeft, this.scrollTop + this.scrollHeight);
}
export default {
  inheritAttrs: false,
  props: {
    ...basicFormProps,
    class: { type: String, default: "form-group" },
    className: { type: String, default: "form-control" },
    autosize: Boolean,
    readonly: Boolean,
    autofocus: Boolean,
  },
  emits: ["update:modelValue", "change"],
  watch: {
    modelValue() {
      if (this.autosize) {
        nextTick().then(() =>
          autoresize({ currentTarget: this.$refs.textarea })
        );
      }
    },
  },
  mounted() {
    if (this.autosize) {
      this.$refs.textarea.addEventListener("input", autoresize, false);
      this.$refs.textarea.addEventListener("change", autoresize, false);
      nextTick().then(() => autoresize({ currentTarget: this.$refs.textarea }));
    }
    if (this.autofocus) {
      this.$refs.textarea?.focus();
    }
  },
  beforeUnmount() {
    if (this.autosize) {
      this.$refs.textarea.removeEventListener("input", autoresize, false);
      this.$refs.textarea.removeEventListener("change", autoresize, false);
    }
  },
  methods: {},
};
</script>
